import _get from 'lodash/get';
import { STTextUnderlineType } from '@tencent/slide-sdk-model';
import { STTextStrikeType } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { getEgColorChoiceRgba } from '@src/slide/infrastructure/module/independent/color/transform';
export const htmlToSdkScale = 12700;// html 中转为sdk的比例
export const htmlToSdkFontScale = 100;
const standard16colorsMapping: {[standard16color: string]: string} = {
    white: 'FFFFFF',
    silver: 'C0C0C0',
    gray: '808080',
    black: '000000',
    red: 'FF0000',
    maroon: '800000',
    yellow: 'FFFF00',
    olive: '808000',
    lime: '00FF00',
    green: '008000',
    aqua: '00FFFF',
    teal: '008080',
    blue: '0000FF',
    navy: '000080',
    fuchsia: 'FF00FF',
    purple: '800080',
};

const deleteOneTagByTagName = (htmlString: any, tagName: any) => {
    if (!tagName) {
        return htmlString;
    }
    let deletedHtmlString = '';
    const indexStart = htmlString.indexOf(`<${tagName}`);
    if (indexStart !== -1) {
        const indexEnd = htmlString.indexOf(`</${tagName}`);
        if (indexEnd !== -1) {
            deletedHtmlString =                htmlString.substring(0, indexStart)
                + htmlString.substring(indexEnd + tagName.length + 3);
            return deletedHtmlString;
        }
    }
    return htmlString;
};

export const randomString = () => {
    const customGroups = 4;
    let randomstring = '';
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16)
            .substring(1);
    }
    for (let i = 0; i < customGroups; i++) {
        randomstring += s4();
    }
    return randomstring;
};

// eslint-disable-next-line @tencent/i18next/no-literal-string
export const defaultStyleString = () => 'border:0.5pt solid #dadbda;empty-cells:show;line-height:normal;background-color:#FFF;color:#000;vertical-align:middle;outline-width:0;word-wrap:break-word;word-break:normal;white-space:pre-line; text-align:left;font-family:\'Microsoft YaHei\',\'微软雅黑\',sans-serif;font-size:10pt;';

export const validUrl = (value: any) => /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);

export const rgba2hex = function (rgba: any) {
    // convert rgb to hex
    const colors = rgba.toString().match(/\d+(\.\d+)?/g); // 把 x,y,z,a 推送到 color 数组里
    let alpha = 1;
    if (typeof colors[3] !== 'undefined') {
        alpha = Number(colors[3]);
    }
    if (alpha === 0) {
        return '';
    }
    let hex = '#';
    if (alpha === 1) {
        for (let i = 0; i < 3; i++) {
            // 'Number.toString(16)' 是JS默认能实现转换成16进制数的方法.
            // 'colors[i]' 是数组，要转换成字符串.
            // 如果结果是一位数，就在前面补零。例如： A变成0A
            // if (alpha == 1) {
            hex += (`0${Number(colors[i]).toString(16)}`).slice(-2);
            // } else {
            //     //转化为6位有问题啊，浏览器看的颜色不同一个
            //     hex += (
            //         '0' +
            //         (Number(colors[i]) * alpha + 255 * (1 - alpha)).toString(16)
            //     ).slice(-2);
            // }
        }
    } else {
        for (let i = 0; i < 3; i++) {
            hex += (`0${Number(colors[i]).toString(16)}`).slice(-2);
        }
        hex += (alpha * 255).toString(16).substring(0, 2);
    }

    return hex;
};

export const getHexColor = function (color: any) {
    if (typeof color !== 'string') {
        return;
    }
    if (color[0] === '#') {
        return color;
    } if (color.substring(0, 3).toLowerCase() === 'rgb') {
        return rgba2hex(color);
    }
    if (standard16colorsMapping[color]) {
        return `#${standard16colorsMapping[color]}`;
    }
};

export const getSolidHexColor = function (color: any) {
    if (typeof color !== 'string') {
        return;
    }
    if (color[0] === '#') {
        return color.substring(1);
    } if (color.substring(0, 3).toLowerCase() === 'rgb') {
        let rgbColor = rgba2hex(color);
        if (rgbColor[0] === '#') {
            rgbColor = rgbColor.substring(1);
        }
        return rgbColor;
    }
    if (standard16colorsMapping[color]) {
        return standard16colorsMapping[color];
    }
};

// 样式对应的默认标签
const styleToTagMap = {
    'font-weight': [{ key: 'B', value: 'bold' }],
    'font-style': [{ key: 'I', value: 'italic' }],
    'text-decoration': [{ key: 'U', value: 'underline' }, { key: 'A', value: 'underline' }, { key: 'S', value: 'line-through' }],
};
export const getTagDefaultStyle = (tagName: string, styleName: string): boolean | undefined  => {
    const styleArr = styleToTagMap[styleName];
    const styleItem = styleArr?.find(item => item.key === tagName);
    if (styleItem) return styleItem.value;
};

export const getAttributeBottomUp = (node, attrName: string): string | undefined => {
    let attribute = node?.getAttribute?.(attrName);
    if (!attribute) {
        let currentNode = node;
        while (currentNode && currentNode.tagName !== 'BODY') {
            currentNode = currentNode.parentNode || currentNode.parentNodeText;
            const parentAttr = currentNode?.getAttribute?.(attrName);
            if (parentAttr) {
                attribute = parentAttr;
                break;
            }
        }
    }
    return attribute;
};

// eslint-disable-next-line complexity
export const adjustStyle = (node, styleKey: string, getComputedStyle?): string | undefined => {
    let styleValue = node.style?.[styleKey] || getTagDefaultStyle(node?.tagName, styleKey); // 自己的style

    // 获取推荐样式，逐层向上查找
    if (!styleValue) {
        styleValue = node?.getAttribute?.(styleKey); // element属性
    }

    if (!styleValue) { // 微软的格式
        const style = getComputedStyle(node);
        styleValue = style?.[styleKey];
    }
    if (!styleValue) { // 父节点的style
        let currentNode = node;
        const tagStyle: string[] = [];
        const styleArr = styleToTagMap[styleKey];
        const isContinue = () => (styleArr ? styleArr.length !== tagStyle.length : !tagStyle.length);
        while (currentNode && currentNode.tagName !== 'HTML' && isContinue()) { // css 检测到html层
            currentNode = currentNode.parentNode || currentNode.parentNodeText; // 兼容text
            if (currentNode) {
                const style = currentNode.style?.[styleKey]
                    || getTagDefaultStyle(currentNode?.tagName, styleKey);
                style && tagStyle.push(style);
            }
        }
        styleValue = tagStyle.join(' ');
    }

    return styleValue;
};

export const getRunText = (textRun) => {
    const { t } = textRun.r || {};
    let resultText = t;
    if (!resultText) {
        resultText = '';
        if (textRun.br) {
            resultText = '\n';
        }
    }
    return resultText;
};

const propsToStyleFont = (rPr, style) => {
    // 字号
    const fontSize = rPr.sz ? parseFloat(rPr.sz) / 100 : 16; // htmlToSdkFontScale
    // eslint-disable-next-line no-param-reassign
    style.fontSize = `${fontSize}pt`;

    // 字体
    let fontFamily = 'DengXian';
    if (rPr.lang === 'zh-CN') {
        if (rPr.ea?.typeface) {
            fontFamily = rPr.ea.typeface;
        }
    } else if (rPr.latin?.typeface) {
        fontFamily = rPr.latin.typeface;
    }
    style.fontFamily = fontFamily;

    if (rPr.i) {
        style.fontStyle = 'italic';
    }

    if (rPr.b) {
        style.fontWeight = 'bold';
    }
};

const propsToStyleDecoration = (rPr, style) => {
    // 斜体
    if (rPr.u && rPr.u !== STTextUnderlineType.none) {
        style.textDecoration += 'underline';
    }

    if (rPr.strike && rPr.strike !== STTextStrikeType.noStrike) {
        style.textDecoration += ' line-through';
    }

    if (rPr.spc) {
        const spcR = rPr.spc / 100; // htmlToSdkFontScale
        style.letterSpacing = `${spcR}pt`;
    }
};

const propsToStyleBackground = (rPr, style) => {
    if (rPr.solidFill?.egColorChoice?.srgbClr) {
        style.color = getEgColorChoiceRgba(rPr.solidFill?.egColorChoice?.srgbClr);
    }

    if (rPr.highlight?.srgbClr) {
        style.backgroundColor = getEgColorChoiceRgba(rPr.highlight?.srgbClr);
    }
};

const propsToStyleLineHeight = (rPr, style) => {
    if (rPr?.lnSpc?.spcPct) {
        style.lineHeight = `${rPr.lnSpc?.spcPct?.val / 1e3}%`;
    }
};

export const propsToStyle = (rPr, style) => {
    if (!rPr) {
        return;
    }
    propsToStyleFont(rPr, style);
    propsToStyleDecoration(rPr, style);
    propsToStyleBackground(rPr, style);
    propsToStyleLineHeight(rPr, style);
};

export const deleteTagByTagName = (htmlString: any, tagName: any) => {
    if (!htmlString || !tagName) {
        return htmlString;
    }
    let deleteHtmlString;
    let lastHtmlString = htmlString;
    let index = 100;
    while (index) {
        index -= 1;
        deleteHtmlString = deleteOneTagByTagName(
            lastHtmlString,
            tagName,
        );
        if (deleteHtmlString === lastHtmlString) {
            return deleteHtmlString;
        }
        lastHtmlString = deleteHtmlString;
    }
    if (index === 0) {
        return '';
    }
    return deleteHtmlString;
};

/**
* 检测是否有项目符号（仅支持目前已知的三种项目符号）
* 1. buNone 0/1 有/无 项目符号
* 2. bulletChar 项目符号是符号类型
* 3. buAutoNum 项目符号是数字类型
* 4. buBlip 项目符号是图片类型
* @param paragraph
* @returns {boolean}
*/
export const hasBullet = (paragraph) => {
    if (!paragraph?.pPr) return false;
    const { buNone, buChar: bulletChar, buAutoNum, buBlip } = paragraph.pPr || {};
    return buNone !== 1 && (bulletChar || buAutoNum || buBlip);
};

/**
 * 是否是文档支持的项目编号且是普通符号类型
 * @param {IParagraph} paragraph
 * @returns {boolean}
 */
export const isCharBullet = paragraph => paragraph?.pPr?.buChar;

/**
 * 是否是文档支持的项目编号且是数字类型
 * @param {IParagraph} paragraph
 * @returns {boolean}
 */
export const isNumberBullet = paragraph => paragraph?.pPr?.buAutoNum;

export const textBodySdkDataToHtml = (sdkData) => {
    const body = document.createElement('div');
    if (_get(sdkData, 'txBody.p.length') > 0) {
        let ulTag;
        sdkData.txBody.p.forEach((paragraph, index) => {
            const hasBu = hasBullet(paragraph);// 是否有项目符号
            let tagP;
            if (hasBu) {
                if (!ulTag) {
                    ulTag = isNumberBullet(paragraph) ? document.createElement('ol') : document.createElement('ul');
                    ulTag.id = index;
                }
                tagP = document.createElement('li');
            } else {
                tagP = document.createElement('p');
                ulTag = null;
            }
            if (paragraph.pPr) {
                // todo
                const { defaultRunProps } = paragraph.pPr;
                propsToStyle(defaultRunProps, tagP.style);
            }
            paragraph.egTextRun?.forEach((textRun) => {
                let tag;
                const { rPr } = textRun.r;
                if (rPr?.hlinkClick) {
                    tag = document.createElement('a');
                    tag.href = rPr.hlinkClick.id;
                } else {
                    tag = document.createElement('span');
                }
                const resultText = getRunText(textRun);
                const textNode = document.createTextNode(resultText);
                tag.appendChild(textNode);

                propsToStyle(rPr, tag.style);

                tagP.appendChild(tag);
            });
            if (ulTag) {
                ulTag.appendChild(tagP);
                const uls = body.getElementsByTagName('ul');
                let ulHasAdd = false;
                if (uls.length > 0) {
                    for (let i = 0; i < uls.length; i++) {
                        const ul = uls[i];
                        if (ul.id === ulTag.id) {
                            ulHasAdd = true;
                        }
                    }
                }
                if (!ulHasAdd) {
                    body.appendChild(ulTag);
                }
            } else {
                body.appendChild(tagP);
            }
        });
    }

    // if (_get(sdkData, 'props.addon.displayMode') === 'iframe') {
    //     const originUrl = _get(sdkData, 'props.addon.originUrl');
    //     const embedUrl = _get(sdkData, 'props.addon.embedUrl');
    //     const extraData = _get(sdkData, 'props.addon.extraData');
    //     const iframeId = _get(sdkData, 'props.addon.iframeId');
    //     const slideData = document.createElement('slide-data');
    //     const innerData = {
    //         originUrl,
    //         embedUrl,
    //         extraData,
    //         iframeId,
    //     };
    //     slideData.setAttribute('data-src', JSON.stringify(innerData));
    //     body.appendChild(slideData);
    // }

    return body.outerHTML;
};
